export default [
  { id: 'twf-001', title: 'book 1', color: '#70afbd' }, //light blue
  { id: 'twf-002', title: 'book 2', color: '#f45425' }, //orange
  { id: 'twf-003', title: 'book 3', color: '#e66169' }, //light red
  { id: 'twf-004', title: 'book 4', color: '#2d5c8b' }, //need new
  { id: 'twf-005', title: 'book 5', color: '#dcac3c' }, //gold
  { id: 'twf-006', title: 'book 6', color: '#61b256' }, //green
  { id: 'twf-007', title: 'book 7', color: '#00c6c6' }, //teal
  { id: 'twf-008', title: 'book 8', color: '#45794f' }, //dark green
  { id: 'twf-009', title: 'book 9', color: '#c85c97' }, //pink
  { id: 'twf-010', title: 'book 10', color: '#666666' }, //grey
]



// WEBPACK FOOTER //
// ./src/data/legend/index.js